import { combineReducers } from 'redux';
import {
  configurationSliceReducer as configuration,
  documentSliceReducer as document,
  categorySliceReducer as category,
  optionSliceReducer as option,
  faqSliceReducer as faq,
  stepSliceReducer as step,
  searchSliceReducer as search,
  authSliceReducer as auth,
} from './slices';

const rootReducer = combineReducers({
  configuration,
  document,
  category,
  option,
  faq,
  step,
  search,
  auth,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
